export const actionTypes = {
  GET_PLANS: "billing/GET_PLANS",
  GET_PLANS_SUCCESS: "billing/GET_PLANS_SUCCESS",
  GET_PLANS_ERROR: "billing/GET_PLANS_ERROR",
  GET_SUBSCRIPTION: "billing/GET_SUBSCRIPTION",
  GET_SUBSCRIPTION_SUCCESS: "billing/GET_SUBSCRIPTION_SUCCESS",
  GET_SUBSCRIPTION_ERROR: "billing/GET_SUBSCRIPTION_ERROR",
  CREATE_CHECKOUT_SESSION: "billing/CREATE_CHECKOUT_SESSION",
  CREATE_CHECKOUT_SESSION_SUCCESS: "billing/CREATE_CHECKOUT_SESSION_SUCCESS",
  CREATE_CHECKOUT_SESSION_ERROR: "billing/CREATE_CHECKOUT_SESSION_ERROR",
  CREATE_PORTAL_SESSION: "billing/CREATE_PORTAL_SESSION",
  CREATE_PORTAL_SESSION_SUCCESS: "billing/CREATE_PORTAL_SESSION_SUCCESS",
  CREATE_PORTAL_SESSION_ERROR: "billing/CREATE_PORTAL_SESSION_ERROR",
  GET_INVOICES: "billing/GET_INVOICES",
  GET_INVOICES_SUCCESS: "billing/GET_INVOICES_SUCCESS",
  GET_INVOICES_ERROR: "billing/GET_INVOICES_ERROR",
  CANCEL_SUBSCRIPTION: "billing/CANCEL_SUBSCRIPTION",
  CANCEL_SUBSCRIPTION_ERROR: "billing/CANCEL_SUBSCRIPTION_ERROR",
  RESUME_SUBSCRIPTION: "billing/RESUME_SUBSCRIPTION",
  RESUME_SUBSCRIPTION_ERROR: "billing/RESUME_SUBSCRIPTION_ERROR",
  CLEAR_BILLING_ERROR: "billing/CLEAR_BILLING_ERROR",
  // "Cancel = pause or close": close a plan-less account / withdraw a pending closure, plus
  // the shared status the two dialogs read (idle -> loading -> success | error).
  CLOSE_ACCOUNT: "billing/CLOSE_ACCOUNT",
  KEEP_ACCOUNT: "billing/KEEP_ACCOUNT",
  ACCOUNT_ACTION_SUCCESS: "billing/ACCOUNT_ACTION_SUCCESS",
  ACCOUNT_ACTION_ERROR: "billing/ACCOUNT_ACTION_ERROR",
  ACCOUNT_ACTION_RESET: "billing/ACCOUNT_ACTION_RESET",
  // Consented cancel of the account's own monthly donation (distinct from
  // CANCEL_SUBSCRIPTION, which a donation/free-sourced row always refuses).
  CANCEL_DONATION: "billing/CANCEL_DONATION",
  CANCEL_DONATION_SUCCESS: "billing/CANCEL_DONATION_SUCCESS",
  CANCEL_DONATION_ERROR: "billing/CANCEL_DONATION_ERROR",
  // Payment Methods
  GET_PAYMENT_METHODS: "billing/GET_PAYMENT_METHODS",
  GET_PAYMENT_METHODS_SUCCESS: "billing/GET_PAYMENT_METHODS_SUCCESS",
  GET_PAYMENT_METHODS_ERROR: "billing/GET_PAYMENT_METHODS_ERROR",
  ADD_PAYMENT_METHOD: "billing/ADD_PAYMENT_METHOD",
  ADD_PAYMENT_METHOD_SUCCESS: "billing/ADD_PAYMENT_METHOD_SUCCESS",
  ADD_PAYMENT_METHOD_ERROR: "billing/ADD_PAYMENT_METHOD_ERROR",
  DELETE_PAYMENT_METHOD: "billing/DELETE_PAYMENT_METHOD",
  DELETE_PAYMENT_METHOD_SUCCESS: "billing/DELETE_PAYMENT_METHOD_SUCCESS",
  DELETE_PAYMENT_METHOD_ERROR: "billing/DELETE_PAYMENT_METHOD_ERROR",
  SET_DEFAULT_PAYMENT_METHOD: "billing/SET_DEFAULT_PAYMENT_METHOD",
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS: "billing/SET_DEFAULT_PAYMENT_METHOD_SUCCESS",
  SET_DEFAULT_PAYMENT_METHOD_ERROR: "billing/SET_DEFAULT_PAYMENT_METHOD_ERROR",
  GET_SETUP_INTENT: "billing/GET_SETUP_INTENT",
  GET_SETUP_INTENT_SUCCESS: "billing/GET_SETUP_INTENT_SUCCESS",
  GET_SETUP_INTENT_ERROR: "billing/GET_SETUP_INTENT_ERROR",
  // Payment History
  GET_PAYMENT_HISTORY: "billing/GET_PAYMENT_HISTORY",
  GET_PAYMENT_HISTORY_SUCCESS: "billing/GET_PAYMENT_HISTORY_SUCCESS",
  GET_PAYMENT_HISTORY_ERROR: "billing/GET_PAYMENT_HISTORY_ERROR",
  // Customer Info
  GET_CUSTOMER: "billing/GET_CUSTOMER",
  GET_CUSTOMER_SUCCESS: "billing/GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_ERROR: "billing/GET_CUSTOMER_ERROR",
  UPDATE_CUSTOMER: "billing/UPDATE_CUSTOMER",
  UPDATE_CUSTOMER_SUCCESS: "billing/UPDATE_CUSTOMER_SUCCESS",
  UPDATE_CUSTOMER_ERROR: "billing/UPDATE_CUSTOMER_ERROR",
  // Invoice Details
  GET_INVOICE: "billing/GET_INVOICE",
  GET_INVOICE_SUCCESS: "billing/GET_INVOICE_SUCCESS",
  GET_INVOICE_ERROR: "billing/GET_INVOICE_ERROR",
  // Auth-injected billing state
  SET_BILLING_FROM_AUTH: "billing/SET_BILLING_FROM_AUTH",
  // Welcome splash
  DISMISS_WELCOME_TRIGGER: "billing/DISMISS_WELCOME_TRIGGER",
  DISMISS_WELCOME_SUCCESS: "billing/DISMISS_WELCOME_SUCCESS",
  // Setup fee / managed upload
  PURCHASE_SETUP_FEE_TRIGGER: "billing/PURCHASE_SETUP_FEE_TRIGGER",
  PURCHASE_SETUP_FEE_SUCCESS: "billing/PURCHASE_SETUP_FEE_SUCCESS",
  UPLOAD_MANAGED_FILE_TRIGGER: "billing/UPLOAD_MANAGED_FILE_TRIGGER",
  UPLOAD_MANAGED_FILE_SUCCESS: "billing/UPLOAD_MANAGED_FILE_SUCCESS",
  // Usage
  GET_USAGE_TRIGGER: "billing/GET_USAGE_TRIGGER",
  GET_USAGE_SUCCESS: "billing/GET_USAGE_SUCCESS",
  // Admin message for re-upload
  SET_MANAGED_UPLOAD_ADMIN_MESSAGE: "billing/SET_MANAGED_UPLOAD_ADMIN_MESSAGE",
  // Payment processing lock screen
  SET_PAYMENT_PROCESSING: "billing/SET_PAYMENT_PROCESSING",
  // Confirm setup purchase via Stripe (fallback for webhook delay)
  CONFIRM_SETUP_PURCHASE: "billing/CONFIRM_SETUP_PURCHASE",
  CONFIRM_SETUP_PURCHASE_SUCCESS: "billing/CONFIRM_SETUP_PURCHASE_SUCCESS",
  // Awaiting payment confirmation (returned from Stripe, waiting for webhook)
  SET_AWAITING_PAYMENT_CONFIRMATION: "billing/SET_AWAITING_PAYMENT_CONFIRMATION",
};
